export default function (validaCpfCnpj, estadoCivil, gentilicos) {
  return {
    NAO_ONEROSO: {
      groups: [
        {
          legend: '01 - DADOS DO PROCESSO',
          styleClasses: 'none',
          fields: [
            {
              column: 8,
              type: 'elementInput',
              model: 'numeroProcesso',
              inputName: 'numeroProcesso',
              visible: true,
              disabled: true,
              required: true,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Processo Administrativo:',
              clearable: true
            },
            {
              column: 8,
              type: 'elementInput',
              model: 'numeroSei',
              inputName: 'numeroSei',
              visible: true,
              disabled: true,
              required: true,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Processo SEI (Sistema Eletrônico de Informações):',
              clearable: true
            },
            {
              column: 24,
              type: 'elementInput',
              model: 'interessado.pessoa.pessoaFisica.nome',
              inputName: 'nomeInteressado',
              visible: true,
              disabled: true,
              required: true,
              readonly: false,
              styleClasses: '',
              inputType: 'text',
              elementLabel: 'Nome Interessado:',
              clearable: true
            },
            {
              column: 8,
              type: 'elementSelect',
              model: 'interessado.pessoa.pessoaFisica.gentilico',
              inputName: 'nacionalidade',
              placeholder: 'Selecione',
              visible: true,
              disabled: true,
              required: true,
              validator: 'required',
              valueKey: 'codigo',
              values: gentilicos,
              filterable: false,
              elementLabel: 'Nacionalidade:'
            },
            {
              column: 8,
              type: 'elementInput',
              model: 'interessado.pessoa.pessoaFisica.estadoCivilFormatado',
              inputName: 'estadoCivil',
              visible: true,
              disabled: true,
              required: true,
              readonly: false,
              styleClasses: '',
              inputType: 'text',
              elementLabel: 'Estado Civil:',
              clearable: true
            },
            {
              column: 8,
              type: 'elementInput',
              model: 'interessado.pessoa.pessoaFisica.rg',
              inputName: 'rgInteressado',
              visible: true,
              disabled: true,
              required: true,
              readonly: false,
              styleClasses: '',
              inputType: 'text',
              elementLabel: 'Nº do RG:',
              clearable: true
            },
            {
              column: 8,
              type: 'elementInput',
              model: 'interessado.pessoa.pessoaFisica.ufRg',
              inputName: 'ufRgInteressado',
              visible: true,
              disabled: true,
              required: true,
              readonly: false,
              styleClasses: '',
              inputType: 'text',
              elementLabel: 'UF do RG:',
              clearable: true
            },
            {
              column: 8,
              type: 'elementInput',
              model: 'interessado.pessoa.pessoaFisica.cpf',
              inputName: 'cpf',
              visible: true,
              disabled: true,
              required: true,
              readonly: false,
              styleClasses: '',
              validator: validaCpfCnpj,
              inputType: 'text',
              elementLabel: 'CPF/CNPJ:',
              clearable: true
            }
          ]
        }
      ]
    }
  }
}



// WEBPACK FOOTER //
// ./src/screens/analise/components/schemaCertidaoArea/schema.js